import { get, post, del } from "common/request"

export const announcementsRequest = {
  list: params => get(`/api/announcements?${params}`),
  activeList: () => get("/api/announcements/active"),
  detail: id => get(`/api/announcement/${id}`),
  delete: id => del(`/api/announcement/${id}`),
  createUpdate: data => post(`/api/announcement`, data),
}
